import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=b4c68716&scoped=true"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/newsPage.scss?vue&type=style&index=0&id=b4c68716&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c68716",
  null
  
)

export default component.exports